
import React, { Component, Fragment } from "react";
import {
    Button
} from 'reactstrap';

class DownloadImage extends Component {

    constructor(props) {
        super(props);


    }

    handleDownload = () => {
        console.log("Download" + this.props.imagePath)
        if (this.props.imagePath) {
            fetch(this.props.imagePath)
                .then(response => response.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'image.jpg');
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                })
                .catch(error => console.error('Error downloading image:', error));
        }
    }
    render() {
        return (
            <div className="btn-actions-pane-right downloadImage" style={{ textAlign: "right" }}>
                <Button
                    className="btn-shadow"
                    color="primary"
                    onClick={this.handleDownload}
                >

                    <i
                        className="pe-7s-download"
                    />

                </Button>
            </div>
        )
    }
}

export default DownloadImage;